import { DateTime } from "luxon";
import z3 from "zod";
import * as z from "zod/v4";

const daysOfWeekSchema = z.union([
  z.literal("monday"),
  z.literal("tuesday"),
  z.literal("wednesday"),
  z.literal("thursday"),
  z.literal("friday"),
  z.literal("saturday"),
  z.literal("sunday"),
]);
export type DayOfWeek = z.infer<typeof daysOfWeekSchema>;
const ScheduleTypeSchema = z.union([
  z.literal("open_hours"),
  z.literal("ordering_hours"),
]);
export type ScheduleType = z.infer<typeof ScheduleTypeSchema>;
export const ScheduledTimeSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  day: daysOfWeekSchema,
  startTime: z
    .string()
    .min(2, "Start Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  endTime: z
    .string()
    .min(2, "End Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  weeklyScheduleUuid: z.string(),
});
export const ScheduledTimesSchema = z.array(ScheduledTimeSchema);
export type ScheduledTime = z.infer<typeof ScheduledTimeSchema>;
export const daysOfWeek: DayOfWeek[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const WeeklyScheduleSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  message: z.string().nullable(),
  scheduleType: ScheduleTypeSchema.catch("ordering_hours"),
});
export const WeeklySchedulesSchema = z.array(WeeklyScheduleSchema);
export type WeeklySchedule = z.infer<typeof WeeklyScheduleSchema>;

// Remove once all files are migrated to zod v4
const z3daysOfWeekSchema = z3.union([
  z3.literal("monday"),
  z3.literal("tuesday"),
  z3.literal("wednesday"),
  z3.literal("thursday"),
  z3.literal("friday"),
  z3.literal("saturday"),
  z3.literal("sunday"),
]);
export type Z3DayOfWeek = z3.infer<typeof z3daysOfWeekSchema>;
export const Z3ScheduledTimeSchema = z3.object({
  id: z3.number(),
  uuid: z3.string(),
  day: z3daysOfWeekSchema,
  startTime: z3
    .string()
    .min(2, "Start Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  endTime: z3
    .string()
    .min(2, "End Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  weeklyScheduleUuid: z3.string(),
});

const Z3ScheduleTypeSchema = z3.union([
  z3.literal("open_hours"),
  z3.literal("ordering_hours"),
]);
export const Z3WeeklyScheduleSchema = z3.object({
  id: z3.number(),
  uuid: z3.string(),
  message: z3.string().nullable(),
  scheduleType: Z3ScheduleTypeSchema.catch("ordering_hours"),
});
export const Z3WeeklySchedulesSchema = z3.array(Z3WeeklyScheduleSchema);
export type Z3WeeklySchedule = z3.infer<typeof Z3WeeklyScheduleSchema>;
